module.exports = __webpack_public_path__ + "img/image-1.4ee05698.jpg";